import {
  createTenantIdInterceptorSetAction,
  createTenantIdSetAction,
} from "./../actions/tenantId";
import { AxiosInstance } from "axios";
import { take, select, call, put } from "redux-saga/effects";
import { AppState } from "../../types";
import { TENANT_ID_SET } from "../actions/tenantId";
import {
  AXIOS_INSTANCE_SET,
  createAxiosInstanceSetAction,
} from "../actions/axios";
import { tenantOverrideAllowedFor } from "./tenantOverrideWhitelist";

export function* tenantQueryParamSaga() {
  while (true) {
    const action: ReturnType<typeof createTenantIdSetAction> = yield take(
      TENANT_ID_SET
    );
    yield call(handleTenantIdSet, action);
  }
}

export function* handleTenantIdSet(
  action: ReturnType<typeof createTenantIdSetAction>
) {
  let tenantId = action.payload.tenantId;
  if (tenantId === "") {
    tenantId = undefined;
  }

  let axios: AxiosInstance = yield select((x: AppState) => x.axios.instance);
  if (!axios) {
    const axiosSetAction: ReturnType<typeof createAxiosInstanceSetAction> = yield take(
      AXIOS_INSTANCE_SET
    );

    axios = axiosSetAction.payload.axios;
  }

  const previousInterceptorId: number = yield select(
    (x: AppState) => x.tenant.interceptorId
  );

  const previousTenantId: string = yield select(
    (x: AppState) => x.tenant.tenantId
  );

  if (tenantId === previousTenantId) {
    return;
  }

  if (previousInterceptorId) {
    axios.interceptors.request.eject(previousInterceptorId);
  }

  const interceptorId = tenantId
    ? axios.interceptors.request.use((config) => {
        if (
          tenantOverrideAllowedFor.some(
            (x) => config.url && config.url.indexOf(x) > -1
          )
        ) {
          config.params = config.params ?? {};
          config.params["__tenant"] = tenantId;
        }
        return config;
      })
    : undefined;
  yield put(
    createTenantIdInterceptorSetAction({
      tenantId,
      interceptorId,
    })
  );
}
